import { render, staticRenderFns } from "./RhRappMenu.vue?vue&type=template&id=875d4e40&scoped=true&"
import script from "./RhRappMenu.vue?vue&type=script&lang=js&"
export * from "./RhRappMenu.vue?vue&type=script&lang=js&"
import style0 from "./RhRappMenu.vue?vue&type=style&index=0&id=875d4e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875d4e40",
  null
  
)

export default component.exports